var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaystor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28.762,
    height: 32.528,
    viewBox: "0 0 28.762 32.528",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.423,
    y1: 0.75,
    x2: 0.529,
    y2: 0.25,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00e2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00c5ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_152671",
    "data-name": "Group 152671",
    transform: "translate(-14.63 -10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103499",
    "data-name": "Path 103499",
    d: "M65.669,39.359,60.16,36.177l-5.639,5.639,5.639,5.639,5.528-3.192a2.863,2.863,0,0,0-.019-4.9Z",
    transform: "translate(-23.672 -15.534)",
    fill: "#ffce00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103500",
    "data-name": "Path 103500",
    d: "M30.849,27.467,15.489,12a2.9,2.9,0,0,0-.859,2.061V40.831a2.9,2.9,0,0,0,.859,2.061Z",
    transform: "translate(0 -1.185)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103501",
    "data-name": "Path 103501",
    d: "M32.1,26.283l5.639-5.639.009-.009-7.556-4.351L20.234,10.43a2.826,2.826,0,0,0-2.9-.057,4.3,4.3,0,0,0-.592.439Z",
    transform: "translate(-1.253)",
    fill: "#00f076"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103502",
    "data-name": "Path 103502",
    d: "M16.742,65.471a4.3,4.3,0,0,0,.592.439,2.962,2.962,0,0,0,1.412.382,2.908,2.908,0,0,0,1.469-.42l9.979-5.826L37.751,55.7l-.009-.009L32.1,50.047Z",
    transform: "translate(-1.253 -23.764)",
    fill: "#f63448"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystor);
export default __webpack_public_path__ + "static/media/playstor.b9c473c4096bb329270d60e7be2e892d.svg";
export { ForwardRef as ReactComponent };